import { configureStore } from '@reduxjs/toolkit'
import reservationSlice from './reservationSlice';
import staffSlice, { staffAuthListener } from './staffSlice';
import agendaSlice from './agendaSlice';

const store = configureStore({
  reducer: {
    reservation: reservationSlice.reducer,
    staff: staffSlice.reducer,
    agenda: agendaSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(staffAuthListener.middleware),
});

export default store;
